// extracted by mini-css-extract-plugin
export var aircallIframe = "_ka-3";
export var fabContainer = "_ka-5";
export var fabRinging = "_ka-6";
export var loadingOverlay = "_ka-4";
export var pulse = "_ka-7";
export var widgetContent = "_ka-2";
export var widgetPanel = "_ka-0";
export var widgetPanelExpanded = "_ka-1";